import { useEffect, useState } from "react";
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import { Box, InputLabel } from "@mui/material";
import Checkbox from "@mui/material/Checkbox";
import React, { memo } from "react";
import { useProductsContext } from "../../Contexts/SidebarContext";
import * as Yup from "yup";
import { Formik, Form, Field, ErrorMessage } from "formik";
import { NetworkManager } from "../../Components/NetworkManager";
import { CommonUtil } from "../../utils/CommonUtil";
import ToastManager from "../../Components/ToastManager";

interface pubDialogue {
  show: boolean;
  onCancelDialogue: Function;
  onSaveLiveTemplateName: Function;
}

const btnStyle = { marginTop: 10 };
function IGLivePublishDialog({
  show,
  onCancelDialogue,
  onSaveLiveTemplateName,
}: pubDialogue) {
  const { pubError, templateInfo } = useProductsContext();

  const initialValues = {
    templateName:
      templateInfo.templateName !== null && templateInfo.templateName !== ""
        ? templateInfo.templateName
        : "",
    checked:
      templateInfo.templateType !== null &&
      templateInfo.templateType !== undefined &&
      templateInfo.templateType === "active"
        ? true
        : false,
  };
  const validationSchema = Yup.object().shape({
    templateName: Yup.string()
      .min(3, "It's too short")
      .required("Please Enter Template Name"),
  });

  const [open, setOpen] = useState(false);
  const [showDefaultField, setShowDefaultField] = useState(false);
  const [templateId, setTemplateId] = useState("");
  const [templateDetails, setTemplateDetails] = useState({
    templateId: "",
    templateName: "",
    templateStatus: "",
  });

  useEffect(() => {
    setOpen(show);
  }, [show]);
  const handleClose = () => {
    onCancelDialogue();
  };

  const onHandleSave = (value: any) => {
    onSaveLiveTemplateName(value.templateName, value.checked, templateId);
    setShowDefaultField(false);
    setTemplateId("");
  };
  const onLiveCheckClick = (event: any) => {
    const fbPageInfo: any = localStorage.getItem("fbPageDetail");
    const recFbPageInfp = JSON.parse(fbPageInfo)?.instagram;
    const isChecked = event.target.checked;
    if (isChecked) {
      const param = `instaId=${recFbPageInfp.instaId}`;

      try {
        NetworkManager.sendJsonRequest(
          "instagram/live/template/checkForActiveLiveTemplate",
          "",
          param,
          "GET",
          true,
          onSuccessCall,
          onErrorCallDefault
        );
      } catch (error) {}
    } else {
      setShowDefaultField(false);
      setTemplateId("");
    }
  };
  const onSuccessCall = (data: any) => {
    var respData = CommonUtil.parseData(data);
    if (respData) {
      if (respData.statusCode === "Insta0000") {
        if (respData.liveTemplateStatus === "active") {
          setTemplateId(respData.liveTemplateId);
          setTemplateDetails({
            ...templateDetails,
            templateId: respData.liveTemplateId,
            templateName: respData.liveTemplateName,
            templateStatus: respData.liveTemplateStatus,
          });
          setShowDefaultField(true);
        }
      }
    }
  };
  const onErrorCallDefault = (err: any) => {
    ToastManager.showToast(
      "Error Occured while setting the template to Non-live ",
      "Error"
    );
  };
  const reSetLiveTemplate = (templateRow: any) => {
    const fbPageInfo: any = localStorage.getItem("fbPageDetail");
    const recFbPageInfp = JSON.parse(fbPageInfo)?.instagram;
    const params = `liveTemplateId=${templateId}&instaId=${
      recFbPageInfp.instaId
    }&setTemplateStatus=${
      templateDetails.templateStatus === "active" ? "inactive" : ""
    }`;
    try {
      NetworkManager.sendJsonRequest(
        "instagram/live/template/setLiveTemplateStatus",
        "",
        params,
        "POST",
        true,
        onSuccessCallResetTemp,
        onErrorCallReset
      );
    } catch (error: any) {
      ToastManager.showToast(
        "Error Occured while setting the template to Live ",
        "Error"
      );
    }
  };
  const onSuccessCallResetTemp = (data: any) => {
    var respData = CommonUtil.parseData(data);
    if (respData) {
      if (respData.statusCode === "Insta0000") {
        ToastManager.showToast(
          "Current template is set from Live to Non-live",
          "Success"
        );
      }
    }
  };
  const onErrorCallReset = (err: any) => {
    ToastManager.showToast(
      "Error Occured while setting the template to Non-live ",
      "Error"
    );
  };
  const onSubmit = (values: any, props: any) => {
    onHandleSave(values);
    props.resetForm();
  };

  return (
    <div>
      <Dialog
        open={open}
        slotProps={{
          paper: {
            sx: {
              width: "80%",
              maxHeight: 600,
            },
          },
        }}>
        <DialogTitle>Template Information</DialogTitle>
        <DialogContent>
          <Formik
            initialValues={initialValues}
            validationSchema={validationSchema}
            onSubmit={onSubmit}>
            {(props) => (
              <Form noValidate>
                <Box
                  sx={{
                    display: "flex",
                    flexWrap: "wrap",
                    gap: 0.5,
                    marginTop: "0.5vh",
                    marginBottom: "2vh",
                  }}>
                  <Field
                    as={Checkbox}
                    label="Default?"
                    type="checkbox"
                    name="checked"
                    onClick={onLiveCheckClick}
                  />
                  <InputLabel sx={{ marginTop: "1.5vh" }}>
                    Set Live Template?
                  </InputLabel>
                </Box>

                {showDefaultField ? (
                  <div style={{ marginLeft: "12px" }}>
                    <InputLabel sx={{ marginTop: "1.5vh" }}>
                      {`There's already a Live Template "${templateDetails.templateName}" attached to the page.`}
                    </InputLabel>

                    <InputLabel>
                      Do you want to replace it with the current one?
                    </InputLabel>
                    <Button
                      type="button"
                      sx={{
                        marginBottom: "10px",
                        backgroundColor: "lightblue",
                        borderRadius: "30%",
                      }}
                      onClick={(row: any) => reSetLiveTemplate(row)}>
                      Yes
                    </Button>
                  </div>
                ) : (
                  ""
                )}
                <Field
                  as={TextField}
                  name="templateName"
                  label="Template Name"
                  fullWidth
                  autoComplete="off"
                  error={
                    props.errors.templateName && props.touched.templateName
                  }
                  disabled={
                    templateInfo.templateName !== null &&
                    templateInfo.templateName !== undefined
                      ? true
                      : false
                  }
                  helpertext={<ErrorMessage name="templateName" />}
                  required
                  value={props.values.templateName}
                />
                <p>{pubError}</p>
                <Button type="submit" style={btnStyle}>
                  Save
                </Button>
                <Button
                  style={btnStyle}
                  onClick={handleClose}
                  disabled={templateId ? true : false}>
                  Cancel
                </Button>
              </Form>
            )}
          </Formik>
        </DialogContent>
      </Dialog>
    </div>
  );
}
export default memo(IGLivePublishDialog);

//onClick={onSubmit}
